const url = '/travel-file-attributes';
const Provider = 'TravelFileAttributes';
const dbModel = 'TravelFileAttributes';

export { url, Provider, dbModel };
